import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const PastCourses = lazyRouteComponent(() => import('@/_instructor/past-future-course/past-courses'));

export const Route = createFileRoute('/_instructor/my-courses/past')({
  component: () => renderInstructorPage(PastCourses),
});
